import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
  viewBox: "0 0 16 16",
  role: "img",
  "aria-label": "Warning:"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, " Link has been expired. ", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "col-md-8"
}
const _hoisted_7 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_8 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_9 = { class: "accordion-item" }
const _hoisted_10 = {
  class: "accordion-header",
  id: "headingOne"
}
const _hoisted_11 = {
  class: "accordion-button",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseOneor",
  "aria-expanded": "true",
  "aria-controls": "collapseOneor"
}
const _hoisted_12 = { class: "badge rounded-pill bg-primary text-end" }
const _hoisted_13 = {
  id: "collapseOneor",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-start fw-bold" }, "Order Number #", -1)
const _hoisted_17 = { class: "col-6 text-end" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-start fw-bold" }, "Order Total", -1)
const _hoisted_20 = { class: "col-6 text-end" }
const _hoisted_21 = {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}
const _hoisted_22 = ["data-bs-target"]
const _hoisted_23 = { class: "badge rounded-pill bg-success ml-5" }
const _hoisted_24 = {
  key: 0,
  class: "badge rounded-pill bg-danger ml-5"
}
const _hoisted_25 = ["id"]
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Drop off Id", -1)
const _hoisted_29 = { class: "col-sm-8 text-end" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Customer Name", -1)
const _hoisted_32 = { class: "col-sm-8 text-end" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Customer Email ", -1)
const _hoisted_35 = { class: "col-sm-8 text-end" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Customer Phone", -1)
const _hoisted_38 = { class: "col-sm-8 text-end" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Customer Address ", -1)
const _hoisted_41 = { class: "col-sm-8 text-end" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Courier Note", -1)
const _hoisted_44 = { class: "col-sm-8 text-end" }
const _hoisted_45 = {
  key: 0,
  class: "row"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-4 text-start fw-bold" }, "Delivered Date", -1)
const _hoisted_47 = { class: "col-sm-8 text-end" }
const _hoisted_48 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "headingOne"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#collapseOne",
    "aria-expanded": "true",
    "aria-controls": "collapseOne"
  }, " Rider Detail ")
], -1)
const _hoisted_50 = {
  id: "collapseOne",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "headingOne",
  "data-bs-parent": "#accordionExample"
}
const _hoisted_51 = { class: "accordion-body" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-start fw-bold" }, "Rider Name", -1)
const _hoisted_54 = { class: "col-6 text-end" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-start fw-bold" }, "Rider Phone", -1)
const _hoisted_57 = { class: "col-6 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isExpire)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (!$setup.isExpire)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_GoogleMap, {
            "api-key": "AIzaSyAfV96tdeqK3NskgsrFNt3H2xUx-2LNOSk",
            style: {"width":"100%","height":"500px"},
            center: { lat: parseFloat($setup.order.pickup_latitude), lng: parseFloat($setup.order.pickup_langitude) },
            zoom: 17
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.order.order_items, (item, index) => {
                return (_openBlock(), _createBlock(_component_Marker, {
                  options: { position: { lat:parseFloat(item.customer_latitude), lng:parseFloat(item.customer_langitude) },  label: 'D '+ (parseInt(index)+1), title:item.customer_address	 },
                  key: index
                }, null, 8, ["options"]))
              }), 128)),
              ($setup.rider.id)
                ? (_openBlock(), _createBlock(_component_Marker, {
                    key: $setup.rider.id,
                    options: { position: { lat: parseFloat($setup.rider.rider_lat), lng: parseFloat($setup.rider.rider_lan) },  label: 'R', title:'Rider '  	 }
                  }, null, 8, ["options"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["center"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isExpire)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h2", _hoisted_10, [
                _createElementVNode("button", _hoisted_11, [
                  _createTextVNode(" Order Detail     "),
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.order.orderstatus?.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, _toDisplayString($setup.order.id), 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, _toDisplayString($setup.order.country?.currency_short_name) + _toDisplayString($setup.order.total_price), 1)
                  ])
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.order.order_items, (orderitem, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: orderitem.id,
                class: "accordion-item"
              }, [
                _createElementVNode("h2", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "accordion-button",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": '#panelsStayOpen-collapse_a-' + orderitem.id,
                    "aria-expanded": "true",
                    "aria-controls": "panelsStayOpen-collapseone"
                  }, [
                    _createTextVNode(" Drop Off Detail " + _toDisplayString($options.doMath(index)) + "      ", 1),
                    _withDirectives(_createElementVNode("span", _hoisted_23, "Delivered", 512), [
                      [_vShow, orderitem.is_delivered]
                    ]),
                    (!orderitem.is_delivered)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Not Delivered"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_22)
                ]),
                _createElementVNode("div", {
                  id: 'panelsStayOpen-collapse_a-' + orderitem.id,
                  class: "accordion-collapse collapse",
                  "aria-labelledby": "panelsStayOpen-headingOne"
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, _toDisplayString(orderitem.id), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, _toDisplayString(orderitem.customer_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, _toDisplayString(orderitem.customer_email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, _toDisplayString(orderitem.customer_phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, _toDisplayString(orderitem.customer_address), 1)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("div", _hoisted_44, _toDisplayString(orderitem.courier_note), 1)
                    ]),
                    (orderitem.delivered_date)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, _toDisplayString(orderitem.delivered_date), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_25)
              ]))
            }), 128)),
            ($setup.rider.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("div", _hoisted_54, _toDisplayString($setup.rider.rider_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createElementVNode("div", _hoisted_57, _toDisplayString($setup.rider.rider_mobile_no), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}